// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_select_option = /** @type {(inputs: { option: NonNullable<unknown> }) => string} */ (i) => {
	return `Select ${i.option}`
};

const el_select_option = /** @type {(inputs: { option: NonNullable<unknown> }) => string} */ (i) => {
	return `Επιλέξτε ${i.option}`
};

const ru_select_option = /** @type {(inputs: { option: NonNullable<unknown> }) => string} */ (i) => {
	return `Выберите ${i.option}`
};

const he_select_option = /** @type {(inputs: { option: NonNullable<unknown> }) => string} */ (i) => {
	return `בחר ${i.option}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ option: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const select_option = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.select_option(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("select_option", locale)
	if (locale === "en") return en_select_option(inputs)
	if (locale === "el") return el_select_option(inputs)
	if (locale === "ru") return ru_select_option(inputs)
	if (locale === "he") return he_select_option(inputs)
	return "select_option"
};